const BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:5311/api/v1';
const CLIENT_ID = import.meta.env.VITE_CLIENT_ID ?? 'console';
const CLIENT_VERSION = import.meta.env.VITE_CLIENT_VERSION ?? '0.1.0';

/** Downloads a custom report CSV with cookie auth. */
export const downloadCustomReportCsv = async (input: {
  churchId: string;
  reportId: string;
  fallbackFilename: string;
}): Promise<void> => {
  const response = await fetch(`${BASE_URL}/reports/custom/${input.reportId}/export`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'text/csv',
      'Content-Type': 'application/json',
      'X-Trinity-Client': `${CLIENT_ID}/${CLIENT_VERSION}`,
      'X-Church-Id': input.churchId,
    },
    body: JSON.stringify({ format: 'csv' }),
  });

  if (!response.ok) {
    throw new Error(`Export failed (${response.status})`);
  }

  const blob = await response.blob();
  const disposition = response.headers.get('Content-Disposition');
  const match = disposition?.match(/filename="([^"]+)"/);
  const filename = match?.[1] ?? input.fallbackFilename;

  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};
